module.exports = __webpack_public_path__ + "img/icon_credit.0e23550d.png";